module.exports = __webpack_public_path__ + "media/03_【アプリ版】点検編_西日本.3bf836c3.mp4";